export const OTHER_LABEL = 'other';
